/**
 * <ReferralHowItWorksStep> — une étape de « Comment ça marche » (molecule).
 *
 * Pastille d'icône, puis la phrase dont la fin peut passer en gras — c'est là que le legacy met ce
 * que chacun gagne (« 1 séance découverte gratuite de 30 min », « 50€ dès qu'il active son
 * abonnement »). La ligne ne dessine pas sa surface : elle vit dans une carte-liste.
 */
import { StyleSheet } from "react-native-unistyles"

import { IconBubble } from "../../atoms/icons/IconBubble"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { type IconName } from "../../atoms/icons/Icon"

export type ReferralHowItWorksStepProps = {
    iconName: IconName
    text: string
    /** La suite de la phrase, en gras — ce que l'étape fait gagner. */
    boldText?: string
    testID?: string
}

export function ReferralHowItWorksStep(props: ReferralHowItWorksStepProps) {
    const { iconName, text, boldText, testID } = props

    return (
        <Row gap="3" align="center" testID={testID}>
            <IconBubble iconName={iconName} size={36} />
            <Text size="text-md" style={styles.text}>
                {text}
                {boldText != null && boldText !== "" && (
                    <Text size="text-md" weight="bold">
                        {boldText}
                    </Text>
                )}
            </Text>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    text: { flex: 1, flexShrink: 1 },
}))
